import React from 'react';

const MyHistory = () => {
    return (
        <div>
            <h4>this is my MyHistory</h4>
        </div>
    );
};

export default MyHistory;